// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-title[data-v-719dc3f7]{flex-shrink:0;font-family:var(--brand-font-primary);font-size:1rem;line-height:1.5rem;font-weight:600;color:var(--base)}address[data-v-719dc3f7]{font-style:normal}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
